export default "__VITE_ASSET__Bz3f1ICf__"